import validate from "/builds/macys/polaris/nuxt-app/pdp/node_modules/nuxt/dist/pages/runtime/validate.js";
import preserve_45request_45route_45global from "/builds/macys/polaris/nuxt-app/pdp/app/middleware/preserve-request-route.global.ts";
import manifest_45route_45rule from "/builds/macys/polaris/nuxt-app/pdp/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  preserve_45request_45route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}